import PropTypes from 'prop-types'
import React from 'react'

import ButtonScrollDown from 'components/ButtonScrollDown'
import SectionWrapper from 'components/SectionWrapper'
import { TextCartSubtitle } from 'styles/components/typography'

import {
  Wrapper,
  H1Styled,
  TitleBox,
  SubtitleBox,
  ButtonScrollBox,
} from './styles'

/**
 * CartHeader
 *
 * @param {object} props - properties of component
 * @returns {node} CartHeader
 */
const CartHeader = ({
  sections,
  texts,
  goodsBlockRef,
  isCartEmpty,
  isTopIndent,
  isLessInfo,
}) => {
  const heading = isCartEmpty ? texts.empty_cart.title : sections.cart

  return (
    <SectionWrapper isWideToDesktop={true}>
      <Wrapper isTopIndent={isTopIndent}>
        <TitleBox>
          <H1Styled dangerouslySetInnerHTML={{ __html: heading }} />
          {!isLessInfo && (
            <>
              {texts.subtitle && (
                <SubtitleBox>
                  <TextCartSubtitle
                    dangerouslySetInnerHTML={{ __html: texts.subtitle }}
                  />
                </SubtitleBox>
              )}
              <ButtonScrollBox>
                <ButtonScrollDown title={''} refToScroll={goodsBlockRef} />
              </ButtonScrollBox>
            </>
          )}
        </TitleBox>
      </Wrapper>
    </SectionWrapper>
  )
}

CartHeader.propTypes = {
  /** Object with texts */
  goodsBlockRef: PropTypes.object.isRequired,

  /** Object with pages' tites */
  sections: PropTypes.object.isRequired,

  /** Ref to block with goods */
  texts: PropTypes.object.isRequired,

  /** Flag to control cart header render */
  isCartEmpty: PropTypes.bool,

  /** Flag to turn on indent between header and banner */
  isTopIndent: PropTypes.bool,

  /** Hide header on desktop and show less info in mobile */
  isLessInfo: PropTypes.bool,
}

CartHeader.defaultProps = {
  isCartEmpty: true,
  isTopIndent: false,
  isLessInfo: false,
}

export default CartHeader
